import { Branding } from "../../../service/branding-service";

/**
 * Header markası — beyaz etiket ortak markalama (co-branding):
 *
 *   Web   : [ kiracının logosu ] │ [ bizim logomuz ]      → müşterinin evi, imzamız yanında
 *   Mobil : [ kiracının logosu ]                          → dar alanda birincil marka kalır (bizimki gizlenir)
 *
 * Kiracı logo yüklememişse (bizim kendi kurulumumuz) yalnızca bizim logomuz görünür — ayraç da çizilmez.
 *
 * Zemin kutusu: kiracının logosu şeffaf değilse (beyaz zeminli PNG) slate header'da yama gibi durur.
 * Marka ayarındaki renk verilmişse logo o rengin kutusuna alınır → kasıtlı, temiz görünür.
 */
export default function Logo() {
    const tenantLogo = Branding.tenantAsset("headerLogo");
    const tenantName = Branding.displayName();
    const background = Branding.logoBackground("headerLogo");

    return (
        <div className="header-brand">
            {tenantLogo && (
                <span
                    className={`header-brand-box ${background ? "has-bg" : ""}`}
                    style={background ? { background } : undefined}
                >
                    <img src={tenantLogo} alt={tenantName || "Logo"} className="header-brand-tenant" />
                </span>
            )}

            {tenantLogo && <span className="header-brand-divider" aria-hidden="true" />}

            <img
                src="/logo-ris.svg"
                alt="RIS · eCloudPACS"
                className={tenantLogo ? "header-brand-own" : "header-brand-tenant"}
            />
        </div>
    );
}
